import { ListHeaderProps } from './ListHeader.props';
import { SearchTextField } from './ListHeader.styles';

const ListHeader = ({
  inputId,
  itemCount = 0,
  onInputChange,
  onInputKeyDown,
  searchState,
  inputFilterRef,
  listLimit = 0,
  searchLabel,
}: ListHeaderProps) => {
  if (itemCount > listLimit) {
    return (
      <SearchTextField
        id={inputId}
        inputRef={inputFilterRef}
        label={searchLabel.toUpperCase()}
        onKeyDown={onInputKeyDown}
        placeholder={searchLabel}
        variant="standard"
        value={searchState}
        onChange={onInputChange}
      />
    );
  }
  return null;
};

export default ListHeader;
